import "./EventVideoGeneratorDialog.scss";

import Dialog, {DialogCloseEventArgs} from "../1. Core/Controls/Dialog/Dialog";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {IBattle, Stage, VideoFile} from "../10. Battle/types";

import BattleVideoGenerator from "./BattleVideoGenerator";
import Select from "../1. Core/Controls/Select/Select";
import Menu, {MenuItemArgs} from "../1. Core/Controls/Menu/Menu";
import Button from "../1. Core/Controls/Button/Button";
import Label from "../1. Core/Controls/Label/Label";
import {secondsToTime} from "../10. Battle/Util";
import TextField from "../1. Core/Controls/TextField/TextField";

import {getBattleMenuItems, showShareDialog} from "./func";


export default class BeforeBattleVideoGeneratorDialog extends Dialog {
	private _Battle: IBattle;
	private _generators: BattleVideoGenerator[];
	private battleSelect: Select;

	private battleMenu: Menu;
	private menuBtn: Button;
	private battles: IBattle[];
	private lbl: Label;

	private _timerLbl: Label;
	private _progressLabel: Label;
	private _streamTimeId: any;
	private startStreamDate: Date;

	_initFields(settings: object)
	{
		this._Battle = null;

		super._initFields(settings);
		this._AutoDestroy = true;
		this._Caption = "Before Battle Video Highlight Creator";
		this._ShowHeader = true;
		this._Mode = 'FullScreen';
		this._ShowButtons = false
	}

	_render()
	{
		super._render();
		this.setCaption(this._Battle.Name);

		this.addClass('event-video-generator')

		NP.addCssClass(this._contentDomNode, 'dialog__surface--fullscreen');
		NP.addCssClass(this._container, 'dialog__container--fullscreen');

		this.getTopAppBar().addItem(this._timerLbl = new Label() as any, this._okButton);
		this._timerLbl.getRoot().style.color = 'black';
		this.getTopAppBar().addItem(this._progressLabel = new Label() as any, this._okButton);
		this._progressLabel.getRoot().style.color = 'black';

		this._okButton.setRK('StartCreateVideo');

		this.refresh();
	}

	async refresh()
	{

		let redBattles = await ServerAPI.post('/battle/items', {
			"Offset": 0,
			"Count": 100,
			"AthleteId": this._Battle.Red,
			"HideStat": true,
			"SortField": "StartTime",
			"SortDirection": 1
		}) as { List: IBattle[] }

		let blueBattles = await ServerAPI.post('/battle/items', {
			"Offset": 0,
			"Count": 100,
			"AthleteId": this._Battle.Blue,
			"HideStat": true,
			"SortField": "StartTime",
			"SortDirection": 1
		}) as { List: IBattle[] }

		this.battles = [...redBattles.List.filter(it => it.VideoUrl), ...blueBattles.List.filter(it => it.VideoUrl)];

		this.createTab();

		this._generators = this.battles
			 .map((b, idx) => new BattleVideoGenerator({
				 Battle: b,
				 RoundPreview: false,
				 SuperWithoutPoint: false,
				 GridHeight: 370,
				 Height: this._Height - 64 - 70 - 40,
				 ParentNode: this._contentNode,
				 IsVisible: false,
				 EvVideoSettingsChanged: (fg: BattleVideoGenerator) =>
				 {
					 let v = fg.getPreviewType();
					 let addFirst = fg.getFirstPreviewVideo();
					 let addEnd = fg.getAddWallpaperToEnd();
					 this._generators.forEach(g =>
					 {
						 if (g != fg)
						 {
							 g.setPreviewType(v)
							 g.setFirstPreviewVideo(addFirst);
							 g.setAddWallpaperToEnd(addEnd);
						 }
					 })
				 }
			 }));
	}


	setHeight(value?: number, fireEvents?: boolean)
	{
		super.setHeight(value, fireEvents);
		this._generators?.forEach(b => b.setHeight(value - 64 - 70 - 40));
	}

	sortList(list: IBattle[])
	{
		return list.sort((a, b) =>
		{
			if (a.Stage == Stage.Maincard)
				return 1;

			if (b.Stage == Stage.Maincard)
				return -1;

			return 0;
		})
	}

	createTab()
	{
		this.menuBtn = new Button({
			ParentNode: this._contentNode,
			Class: 'app-button--raised',
			RK: 'ManageBattleList',
			Menu: this.battleMenu = new Menu({
				EvItemSelected: (s: object, e: MenuItemArgs) =>
				{
					e.IsCancelClose = true;
					e.Item.setIsChecked(!e.Item.getIsChecked())
					this.refreshBattleSelect()
					this._generators.forEach(g => g.setIsVisible(false));
				}
			})
		})


		this.battleMenu.addItems(getBattleMenuItems(this.battles))

		this.battleMenu.getItems().forEach(item => item.setIsChecked && item.setIsChecked(true))

		this.lbl = new Label({RK: 'SelectTheBattle', ParentNode: this._contentNode, Class: 'select-battle'})

		this.battleSelect = new Select({
			ParentNode: this._contentNode,
			Width: 300,
			SelectedIndex: 0,
			EvItemSelected: (s: object, e: { Item: { Value: number } }) =>
			{
				this._generators.forEach((g, idx) => g.setIsVisible(e.Item.Value == g.getBattle().Id))
				this.setHeight(this._Height)
			}
		});


		this.refreshBattleSelect();

	}

	getSelectedBattles()
	{
		return this.battleMenu.getItems().filter(item => item.getIsChecked && item.getIsChecked()).map(item => item.getValue()) as IBattle[]
	}

	refreshBattleSelect()
	{
		this.battleSelect.setItems(this.getSelectedBattles().map((b, idx) => ({
			Value: b.Id,
			Content: b.RedName + ' vs ' + b.BlueName
		})));
	}




	async _onOkButtonClick()
	{
		let selectedBattles = this.getSelectedBattles();
		if (!selectedBattles.length)
			return;

		(new Dialog({
			Content: new TextField({
				FloatingLabel: 'Enter name of the video',
			}),
			EvOkButtonClick: (dlg: Dialog, args: DialogCloseEventArgs) =>
			{
				let name = dlg.getContent().getValue().trim();
				if (name)
				{
					dlg.hide()
					this.doCreateVideo(name, selectedBattles)
				}
				else
					args.IsCancelClose = true
			}
		})).show()
	}

	async doCreateVideo(name: string, selectedBattles: IBattle[])
	{
		try
		{

			this._topAppBar.showWaiter()


			this.startStreamDate = new Date();
			this._streamTimeId = setTimeout(() => this.recalcDate(), 1000);
			setTimeout(() => this.recalcProgress(), 1000);
			this._timerLbl.setContent('00:00');

			let payload = this._generators.filter(g => selectedBattles.find(sb => sb.Id == g.getBattle().Id)).map(g => ({
				battleId: g.getBattle().Id,
				funnyList: g.getFunnyList(),
				rows: g.getSelectedActionList(),
				addPreviewVideo: g.getRoundPreviewVideo(),
				addFirstPreviewVideo: g.getFirstPreviewVideo(),
				compressAndSort: true,
				videoStartTime: g.getVideoWorldStartWorldTime(),
				videoType: g.getVideoType(),
				previewType: g.getPreviewType(),
				addWallpaperToEnd: g.getAddWallpaperToEnd(),
			}));

			let res = await ServerAPI.post<VideoFile>(`/video/createEventVideo/${this._Battle.Id}?&name=${name}`, payload);

			showShareDialog(res)

		} finally
		{
			this.startStreamDate = null;
			this._topAppBar.hideWaiter();
		}
	}

	async recalcDate()
	{
		if (this.startStreamDate)
		{
			let t = new Date().getTime() - this.startStreamDate.getTime();
			this._timerLbl.setContent(secondsToTime(t / 1000));

			this._streamTimeId = setTimeout(() => this.recalcDate(), 800);
		}
	}

	async recalcProgress()
	{
		let info = await ServerAPI.get<{ message: string }>(`/video/getCreateHLProgress/${this._Battle.Id}`)
		if (info)
		{
			this._progressLabel.setContent(' ' + info.message)
			setTimeout(() => this.recalcProgress(), 1000);
		}
		else
			this._progressLabel.setContent('')
	}
}
